
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features-online-money-earning-app",
      function () {
        return require("private-next-pages/features-online-money-earning-app/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features-online-money-earning-app"])
      });
    }
  